module.exports = __webpack_public_path__ + "bdb4b77308bf1f287a48b7d495c96b0c.pdf";